import React from 'react';
import LuxityLoader from 'components/LuxityLoader';

const WAITING =
  "We're still getting things ready. This will only take a moment.";

const FAILED =
  'Something has gone wrong while getting your page ready. Our team has been notified, please check back in a few minutes.';

const AchievementsWaiting = ({ isExhausted }) => (
  <div className="achievements-waiting">
    {isExhausted ? null : <LuxityLoader />}
    <p className="achievements-waiting__message">
      {isExhausted ? FAILED : WAITING}
    </p>
  </div>
);

export default AchievementsWaiting;
